import type { ReactNode } from 'react';
import { cn } from '../cn.ts';

/**
 * Nhãn nhỏ chữ hoa trên tiêu đề section — component lặp nhiều nhất của thiết kế (11 lần).
 *
 * Sáu màu, đo từ 11 chỗ dùng thật (`reference.md` §3), KHÔNG suy được từ nền:
 *   brand       6 lần — mọi eyebrow trên nền sáng
 *   accent      1 lần — `#security` (nền `surface-black`)
 *   on-gradient 1 lần — `#ai` (nền gradient navy), dùng brand-400
 *   neutral     1 lần — dải logo khách hàng
 *   white       1 lần — badge hero
 *   on-dark     1 lần — "Ví dụ agent trong workspace demo" (`#ai`)
 *
 * Font: Inter (`--font-sans`). Thiết kế khai `'DM Sans'` ở cả 11 chỗ nhưng bundle không có
 * `@font-face` nào cho nó ⇒ nó đã rơi về Inter. Khai đúng thứ đang hiển thị, không khai thứ
 * CSS nói.
 */
export interface EyebrowProps {
  readonly children: ReactNode;
  readonly tone?: 'brand' | 'accent' | 'on-gradient' | 'neutral' | 'white' | 'on-dark';
  readonly className?: string;
}

const TONE = {
  brand: 'text-brand-600',
  accent: 'text-accent',
  'on-gradient': 'text-brand-400',
  neutral: 'text-ink-500',
  white: 'text-white',
  'on-dark': 'text-[var(--on-dark-text-50)]',
} as const;

export function Eyebrow({ children, tone = 'brand', className }: EyebrowProps) {
  return (
    <p
      className={cn(
        'font-sans text-eyebrow font-semibold tracking-eyebrow uppercase',
        TONE[tone],
        className,
      )}
    >
      {children}
    </p>
  );
}
